import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DocumentDetailDto } from '@shared/src/dtos/document/DocumentDetailDto';
import { RouteECMRActionsDto } from '@shared/src/dtos/route/cmr/RouteECMRActionsDto';
import { Route_eCMRDto } from '@shared/src/dtos/route/cmr/Route_eCMRDto';
import { RoutePartCMRDto } from '@shared/src/dtos/route/cmr/RoutePartCMRDto';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Observable } from 'rxjs';
import { BaseController } from '../base.controller';
import { RoutePartCMRSignatureAgents } from '../route/cmr/RoutePartCMRSignatureAgents';
import { RouteCMRAgents } from '../route/cmr/RouteCMRAgents';
import { RoutePartCMRSignatureDto } from '../route/cmr/RoutePartCMRSignatureDto';
import { RoutePartCMRSignDto } from '../route/cmr/RoutePartCMRSignDto';
import { RoutePartCMRSignListDto } from '../route/cmr/RoutePartCMRSignListDto';
import { UUIDSignatureDto } from '../route/cmr/UUIDSignatureDto';
import { SecurityController } from '../security/security.controller';
import { RouteCMRAgentDto } from '@shared/src/dtos/route/cmr/agent/RouteCMRAgentDto';
import { RouteCMRAgentPhaseExpandDto } from '@shared/src/dtos/route/cmr/agent/RouteCMRAgentPhaseExpandDto';
import { RouteCMRAgentActionsDto } from '@shared/src/dtos/route/cmr/agent/RouteCMRAgentActionsDto';
import { ECMREventDto } from '@shared/src/dtos/route/cmr/ECMREventDto';
import { SaveECMREventDto } from '@shared/src/dtos/route/cmr/SaveECMREventDto';
import { SaveCMRAgentEventDto } from '@shared/src/dtos/route/cmr/agent/SaveCMRAgentEventDto';
import { RouteCMRAgentPhaseExpandBaseDto } from '@shared/src/dtos/route/cmr/agent/RouteCMRAgentPhaseExpandBaseDto';
import { RouteCMRAgentGoodsDto } from '@shared/src/dtos/route/cmr/agent/RouteCMRAgentGoodsDto';
import { RouteCMRAgentRoutePartECMRDto } from '@shared/src/dtos/route/cmr/agent/RouteCMRAgentRoutePartECMRDto';
import { FileUpDownLoadDto } from '@shared/src/dtos/base/FileUpDownLoadDto';
import { RouteCMRBaseDto } from '@shared/src/dtos/route/cmr/RouteCMRBaseDto';
import { Route_eCMRPartnerDTO } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRPartnerDto';
import { Route_eCMRIncotermDto } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRIncotermDto';
import { Route_eCMRConditionsDto } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRConditionsDto';
import { Route_eCMRHandlingAndTransportationDto } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRHandlingAndTransportationDto';
import { Route_eCMRPaymentDto } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRPaymentDto';
import { Route_eCMRAddressDTO } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRAddressDto';
import { Route_eCMRPlatesDto } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRPlatesDto';
import { Route_eCMRDeliveryLinesDto } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRDeliveryLinesDto';
import { Route_eCMRTransportDateDto } from '@shared/src/dtos/route/cmr/ecmrparts/Route_eCMRTransportDateDto';
import { RouteDeliveryNotesDto } from '@shared/src/dtos/route/cmr/RouteDeliveryNotesDto';


@Injectable({
    providedIn: 'root',
})
export class OpenRouteCMRController extends BaseController {

    private base = '/public/routecmr'

    constructor(
        @Inject('SecurityController') protected securityController: SecurityController,
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router
    ) {
        super(http, alertService, translateService, loadingService, router);
    }


    public getSignByAgentAndUUID(agent: any, uuid: string): Observable<UUIDSignatureDto> {
        return this.get(this.base + "/sign/agent/" + agent + "/uuid/" + uuid);
    }
    public getRoute_eCMR(routePartCMRId: number): Observable<Route_eCMRDto> {
        return this.get(this.base + "/routeecmr/" + routePartCMRId);
    }
    public getRoute_eCMRByUUID(routeUUDQR: string): Observable<Route_eCMRDto> {
        return this.get(this.base + "/routeecmr/byuuid/" + routeUUDQR);
    }
    public getRoute_eCMRByPhaseId(phaseId: number): Observable<Route_eCMRDto> {
        return this.get(this.base + "/routeecmr/phase/" + phaseId);
    }
    public getRoute_eCMRByPhaseUUID(phaseUUID: string): Observable<Route_eCMRDto> {
        return this.get(this.base + "/routeecmr/byphaseuuid/" + phaseUUID);
    }
    public getRouteDeliveryNotes(routePartCMRId: number): Observable<RouteDeliveryNotesDto> {
        return this.get(this.base + "/routedeliverynotes/" + routePartCMRId);
    }
    public getRoute_eCMRActions(routePartCMRId: number): Observable<RouteECMRActionsDto> {
        return this.get(this.base + "/routeecmr/actions/" + routePartCMRId);
    }
    public getRoute_eCMRActionsByUUID(routeUUDQR: string): Observable<RouteECMRActionsDto> {
        return this.get(this.base + "/routeecmr/actions/byuuid/" + routeUUDQR);
    }
    public getRoute_eCMRActionsByPhaseId(phaseId: number): Observable<RouteECMRActionsDto> {
        return this.get(this.base + "/routeecmr/actions/phase/" + phaseId);
    }
    public getRoute_eCMRActionsByPhaseIdAndAgent(phaseId: number, agent: RoutePartCMRSignatureAgents): Observable<RouteECMRActionsDto> {
        return this.get(this.base + "/routeecmr/actions/phase/" + phaseId + "/agent/" + agent);
    }
    public getRoute_eCMRActionsByPhaseUUID(phaseUUID: string): Observable<RouteECMRActionsDto> {
        return this.get(this.base + "/routeecmr/actions/byphaseuuid/" + phaseUUID);
    }
    public autoSignByPhaseId(phaseId: number): Observable<Boolean> {
        return this.postBusy(this.base + "/routeecmr/actions/phase/" + phaseId + "/autosign", null, "autoSignByPhaseId");
    }
    public autoSignByPhaseUUID(phaseUUID: string): Observable<Boolean> {
        return this.postBusy(this.base + "/routeecmr/actions/byphaseuuid/" + phaseUUID + "/autosign", null, "autoSignByPhaseUUID");
    }
    public recalculateByPhaseId(phaseId: number): Observable<Boolean> {
        return this.postBusy(this.base + "/routeecmr/actions/phase/" + phaseId + "/recalculate", null, "recalculateByPhaseId");
    }
    public sendMsgSignatureByPhaseId(phaseId: number): Observable<Boolean> {
        return this.postBusy(this.base + "/routeecmr/actions/phase/" + phaseId + "/sendmsgsignature", null, "sendMsgSignatureByPhaseId");
    }
    public sendMsgDocumentationByPhaseId(phaseId: number): Observable<Boolean> {
        return this.postBusy(this.base + "/routeecmr/actions/phase/" + phaseId + "/sendmsgdocumentation", null, "sendMsgDocumentationByPhaseId");
    }
    public sendEmailSignatureByPhaseId(phaseId: number, agent: RoutePartCMRSignatureAgents): Observable<Boolean> {
        return this.postBusy(this.base + "/routeecmr/actions/phase/" + phaseId + "/agent/" + agent + "/sendemailsignature", null, "sendEmailSignatureByPhaseId");
    }
    public sendEmailDocumentationByPhaseId(phaseId: number, agent: RoutePartCMRSignatureAgents): Observable<Boolean> {
        return this.postBusy(this.base + "/routeecmr/actions/phase/" + phaseId + "/agent/" + agent + "/sendemaildocumentation", null, "sendEmailDocumentationByPhaseId");
    }
    public removeSignatureByPhaseId(phaseId: number, agent: RoutePartCMRSignatureAgents): Observable<Boolean> {
        return this.postBusy(this.base + "/routeecmr/actions/phase/" + phaseId + "/agent/" + agent + "/removesignature", null, "removeSignatureByPhaseId");
    }
    getRoutePartCMR(routePartCMRId: number): Observable<RoutePartCMRDto> {
        return this.get(this.base + "/routepartcmr/" + routePartCMRId);
    }
    public getLastDocumentDetailsCMR(routePartCMRId: number): Observable<DocumentDetailDto[]> {
        return this.get(this.base + "/routeecmr/last/documentdetails/cmr/" + routePartCMRId);
    }

    getRoutePartCMRSignature(routePartCMRId: number, type: RoutePartCMRSignatureAgents): Observable<RoutePartCMRSignDto> {
        return this.get(this.base + "/routepartcmr/" + routePartCMRId + "/sign/" + type);
    }
    getSignUUIDSignature(singUUID: string, type: RoutePartCMRSignatureAgents): Observable<RoutePartCMRSignDto> {
        return this.get(this.base + "/signUUID/" + singUUID + "/sign/" + type);
    }

    getRoutePartCMRSignatureNew(routePartCMRId: number, type: RoutePartCMRSignatureAgents): Observable<RoutePartCMRSignDto> {
        return this.get(this.base + "/routepartcmr/" + routePartCMRId + "/sign/" + type + "/new");
    }
    getRoutePartCMRSignatureNewUUID(uuid: string, type: RoutePartCMRSignatureAgents): Observable<RoutePartCMRSignDto> {
        return this.get(this.base + "/uuid/" + uuid + "/sign/" + type + "/new");
    }

    doSignature(routePartCMRId: number, type: RoutePartCMRSignatureAgents, signatureObject: RoutePartCMRSignatureDto): Observable<Boolean> {
        return this.postBusy(this.base + "/routepartcmr/" + routePartCMRId + "/sign/" + type, signatureObject, "doSignature");
    }
    doSignatureUUID(uuid: string, type: RoutePartCMRSignatureAgents, signatureObject: RoutePartCMRSignatureDto): Observable<Boolean> {
        return this.postBusy(this.base + "/uuid/" + uuid + "/sign/" + type, signatureObject, "doSignatureUUID");
    }

    doPrint(routePartCMRId: number, type: RoutePartCMRSignatureAgents): Observable<Boolean> {
        return this.getBusy(this.base + "/routepartcmr/" + routePartCMRId + "/print/" + type);
    }

    public saveECMREvent(value: SaveECMREventDto): Observable<boolean> {
        return this.post(this.base + "/routepartcmr/events/save", value, "saveECMREvent");
    }

    public updateOriginTenant(routePartCMRId: number, data: Route_eCMRPartnerDTO): Observable<Boolean> {
        return this.put(this.base + "/" + routePartCMRId + "/updateorigintenant", data, "updateOriginTenant");
    }

    public updateDestinationTenant(routePartCMRId: number, data: Route_eCMRPartnerDTO): Observable<Boolean> {
        return this.put(this.base + "/" + routePartCMRId + "/updatedestinationtenant", data, "updateDestinationTenant");
    }

    public updateCarrier(routePartCMRId: number, data: Route_eCMRPartnerDTO): Observable<Boolean> {
        return this.put(this.base + "/" + routePartCMRId + "/updatecarrier", data, "updateCarrier");
    }

    public updateEffectiveCarrier(routePartCMRId: number, data: Route_eCMRPartnerDTO): Observable<Boolean> {
        return this.put(this.base + "/" + routePartCMRId + "/updateeffectivecarrier", data, "updateEffectiveCarrier");
    }

    public updateDriver(routePartCMRId: number, data: Route_eCMRPartnerDTO): Observable<Boolean> {
        return this.put(this.base + "/" + routePartCMRId + "/updatedriver", data, "updateDriver");
    }

    public updateApplicant(routePartCMRId: number, data: Route_eCMRPartnerDTO): Observable<Boolean> {
        return this.put(this.base + "/" + routePartCMRId + "/updateapplicant", data, "updateApplicant");
    }

    public updatePayer(routePartCMRId: number, data: Route_eCMRPartnerDTO): Observable<Boolean> {
        return this.put(this.base + "/" + routePartCMRId + "/updatepayer", data, "updatePayer");
    }

    public updateIncoterm(routePartCMRId: number, data: Route_eCMRIncotermDto): Observable<Boolean> {
        return this.put(this.base + "/" + routePartCMRId + "/updateincoterm", data, "updateIncoterm");
    }

    public updateConditions(routePartCMRId: number, data: Route_eCMRConditionsDto): Observable<Boolean> {
        return this.put(this.base + "/" + routePartCMRId + "/updateconditions", data, "updateConditions");
    }

    public updateHandlingAndTransportation(routePartCMRId: number, data: Route_eCMRHandlingAndTransportationDto): Observable<Boolean> {
        return this.put(this.base + "/" + routePartCMRId + "/updatehandlingandtransportation", data, "updateHandlingAndTransportation");
    }

    public updatePayment(routePartCMRId: number, data: Route_eCMRPaymentDto): Observable<Boolean> {
        return this.put(this.base + "/" + routePartCMRId + "/updatepayment", data, "updatePayment");
    }

    public updateOriginAddress(routePartCMRId: number, data: Route_eCMRAddressDTO): Observable<Boolean> {
        return this.put(this.base + "/" + routePartCMRId + "/updateoriginaddress", data, "updateOriginAddress");
    }

    public updateDestinationAddress(routePartCMRId: number, data: Route_eCMRAddressDTO): Observable<Boolean> {
        return this.put(this.base + "/" + routePartCMRId + "/updatedestinationaddress", data, "updateDestinationAddress");
    }


    doPrintUUID(uuid: string, type: RoutePartCMRSignatureAgents): Observable<Boolean> {
        return this.getBusy(this.base + "/uuid/" + uuid + "/print/" + type);
    }

    doRemoveSignature(uuid: string, type: RoutePartCMRSignatureAgents): Observable<Boolean> {
        return this.getBusy(this.base + "/uuid/" + uuid + "/removesignature/" + type);
    }

    actualizedCMRFromChilds(routePartCMRId: number): Observable<Boolean> {
        return this.getBusy(this.base + "/routepartcmr/" + routePartCMRId + "/actualizedcmrfromchilds");
    }
    
    getSignUUIDHistory(singUUID: string, type: RoutePartCMRSignatureAgents): Observable<RoutePartCMRSignListDto[]> {
        return this.get(this.base + "/signUUID/" + singUUID + "/sign/" + type + "/history");
    }

    getRoutePartCMRByUUID(uuidQR: string): Observable<RoutePartCMRDto> {
        return this.get(this.base + "/cmr/byuuid/" + uuidQR);
    }

    getRouteCMRBaseByUUID(uuidQR: string): Observable<RouteCMRBaseDto> {
        return this.get(this.base + "/byuuid/" + uuidQR + "/base");
    }

    getRoutePartCMRsByUUID(uuidQR: string): Observable<RoutePartCMRDto[]> {
        return this.get(this.base + "/byuuid/" + uuidQR);
    }

    getRoutePartCMRsByPhaseUUID(phaseUUID: string): Observable<RoutePartCMRDto[]> {
        return this.get(this.base + "/byphaseuuid/" + phaseUUID);
    }

    getRouteCMRAgentByUUID(uuidQR: string, agent: RouteCMRAgents): Observable<RouteCMRAgentDto> {
        return this.get(this.base + "/agent/" + agent + "/byuuid/" + uuidQR);
    }

    getRouteCMRAgentActionsCtrlByUUID(uuidQR: string, agent: RouteCMRAgents): Observable<RouteCMRAgentActionsDto> {
        return this.get(this.base + "/agent/" + agent + "/byuuid/" + uuidQR + "/actions");
    }

    getRouteCMRAgentPhaseToSigningByUUID(uuidQR: string, agent: RouteCMRAgents): Observable<RouteCMRAgentPhaseExpandBaseDto[]> {
        return this.get(this.base + "/agent/" + agent + "/byuuid/" + uuidQR + "/phasestosigning");
    }

    getCanAddRouteCMRAgentEventsByUUID(uuidQR: string, agent: RouteCMRAgents): Observable<boolean> {
        return this.get(this.base + "/agent/" + agent + "/byuuid/" + uuidQR + "/canaddevents");
    }
    getRouteCMRAgentEventsByUUID(uuidQR: string, agent: RouteCMRAgents): Observable<ECMREventDto[]> {
        return this.get(this.base + "/agent/" + agent + "/byuuid/" + uuidQR + "/events");
    }
    
    public saveCommentByPhaseUUID(phaseUUID: string, agent: RouteCMRAgents, value: SaveCMRAgentEventDto): Observable<boolean> {
        return this.postBusy(this.base + "/agentphase/" + agent + "/byphaseuuid/" + phaseUUID + "/comment/save", value, "saveCommentByPhaseUUID");
    }
    saveRouteCMRAgentEventByUUID(uuidQR: string, agent: RouteCMRAgents, value: SaveCMRAgentEventDto): Observable<boolean> {
        return this.post(this.base + "/agent/" + agent + "/byuuid/" + uuidQR + "/events/save", value, "saveRouteCMRAgentEvent");
    }
    
    getRouteCMRAgentPhaseByUUID(uuid: string, agent: RouteCMRAgents): Observable<RouteCMRAgentPhaseExpandDto> {
        return this.get(this.base + "/agentphase/" + agent + "/byphaseuuid/" + uuid);
    }
        
    getRouteCMRAgentGoodsByUUID(uuidQR: string, agent: RouteCMRAgents): Observable<RouteCMRAgentGoodsDto> {
        return this.get(this.base + "/agent/" + agent + "/byuuid/" + uuidQR + "/goods");
    }

    getRouteCMRAgentGoodsByPhaseUUID(phaseUUID: string, agent: RouteCMRAgents): Observable<RouteCMRAgentGoodsDto> {
        return this.get(this.base + "/agent/" + agent + "/byphaseuuid/" + phaseUUID + "/goods");
    }

    
    getRouteCMRAgentListECMRsByUUID(uuidQR: string, agent: RouteCMRAgents): Observable<RouteCMRAgentRoutePartECMRDto[]> {
        return this.get(this.base + "/agent/" + agent + "/byuuid/" + uuidQR + "/listecmrs");
    }

    getRouteCMRAgentListECMRsByPhaseUUID(phaseUUID: string, agent: RouteCMRAgents): Observable<RouteCMRAgentRoutePartECMRDto[]> {
         return this.get(this.base + "/agent/" + agent + "/byphaseuuid/" + phaseUUID + "/listecmrs");
    }

    getRoutePartCMRPDF(routePartCMRId: number): Observable<FileUpDownLoadDto> {
            return this.get(this.base + "/download/pdf/routepartcmr/id/" + routePartCMRId)
    }

    getRoutePartCMRDeliveryNotesPDF(routePartCMRId: number): Observable<FileUpDownLoadDto> {
            return this.get(this.base + "/download/pdf/deliverynotes/routepartcmr/id/" + routePartCMRId)
    }

    getRouteDeliveryNotesPDFByUUID(routeUUDQR: string): Observable<FileUpDownLoadDto> {
        return this.get(this.base + "/download/pdf/deliverynotes/route/byuuid/" + routeUUDQR)
    }

    getPhaseDeliveryNotesPDF(phaseId: number): Observable<FileUpDownLoadDto> {
        return this.get(this.base + "/download/pdf/deliverynotes/phase/id/" + phaseId)
    }

    getPhaseDeliveryNotesPDFByPhaseUUID(phaseUUID: string): Observable<FileUpDownLoadDto> {
        return this.get(this.base + "/download/pdf/deliverynotes/phase/byphaseuuid/" + phaseUUID)
    }

    getRoutePDFByUUID(routeUUDQR: string): Observable<FileUpDownLoadDto> {
        return this.get(this.base + "/download/pdf/route/byuuid/" + routeUUDQR)
    }

    getPhasePDF(phaseId: number): Observable<FileUpDownLoadDto> {
        return this.get(this.base + "/download/pdf/phase/id/" + phaseId)
    }
    
    getPhasePDFByPhaseUUID(phaseUUID: string): Observable<FileUpDownLoadDto> {
        return this.get(this.base + "/download/pdf/phase/byphaseuuid/" + phaseUUID)
    }

    getTenantIdByUUID(uuidQR: string): Observable<number> {
        return this.get(this.base + "/tenantid/byuuid/" + uuidQR);
    }

    public updatePlates(routePartCMRId: number, data: Route_eCMRPlatesDto): Observable<Boolean> {
        return this.put(this.base + "/" + routePartCMRId + "/updateplates", data, "updatePlates");
    }

    public updateDeliveryLines(routePartCMRId: number, data: Route_eCMRDeliveryLinesDto): Observable<Boolean> {
        return this.put(this.base + "/" + routePartCMRId + "/updatedeliverylines", data, "updateDeliveryLines");
    }

    public updateTransportDate(routePartCMRId: number, data: Route_eCMRTransportDateDto): Observable<Boolean> {
        return this.put(this.base + "/" + routePartCMRId + "/updatetransportdate", data, "updateTransportDate");
    }
}
